// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xp_a bht_a bht_x","StrollerDetailRating__muted":"xp_b bht_fo"};